const NS = 'VideoModalBlock';
const CLS = 'videoModalBlock';

export class VideoModalBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.$modal = this.$element.find(`.modal`);
		this.$modal.addClass('modal--black');
		this.$iframe = this.$modal.find('.videoBlock-iframe');

		this.$videoContainer = this.$element.find(`.${CLS}-videoContainer`);
		this.$videoContainer.on('click', () => {
			let videoSrcId = this.$element.data('videoSrcId');
			let src = `https://www.youtube.com/embed/${videoSrcId}?autoplay=1&showinfo=0&controls=0`;
			if(videoSrcId) {
				this.$modal.modal('show');
				$('.modal-backdrop').addClass('modal-backdrop--black');
				this.$iframe.attr('src', src);
			}
			else {
				console.error(`${NS}::Error`, 'Please supply a video-src-id to load a video on the modal.');
			}
		});

		this.$modal.on('hidden.bs.modal', () => {
			this.$iframe.removeAttr('src');
		});
	}
}
